// extracted by mini-css-extract-plugin
module.exports = {"tab":"CounterpartyTabs_tab__1CKi1","active-tab":"CounterpartyTabs_active-tab__3K3Nx"};